import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    rubroId: 0,
    codigo: '',
    nombre: '',
    excluidoCalculoRN: false,
    excluidoResumenGastos: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, params) {
        state.id = params.subrubroId;
        state.rubroId = params.rubroId;
        state.codigo = '';
        state.nombre = '';
        state.excluidoCalculoRN = false;
        state.excluidoResumenGastos = false;
        state.rowVersion = null;
    },
    'SET_SUBRUBRO'(state, subrubro) {
        state.codigo = subrubro.codigo.trim();
        state.nombre = subrubro.nombre.trim();
        state.excluidoCalculoRN = ((/true/i).test(subrubro.excluidoCalculoRN));
        state.excluidoResumenGastos = ((/true/i).test(subrubro.excluidoResumenGastos));
        state.rowVersion = subrubro.rowVersion;
    },

};

const actions = {
    inicializar: ( { commit }, params )  => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            let rubroId = 0;
            let subrubroId = 0;

            if (params.rubroId) {
                rubroId = params.rubroId;
            }
            if (params.subrubroId) {
                subrubroId = params.subrubroId;
            }

            if (params.rubroId != 0) {
                apiAxios.get('subrubros/' + rubroId + '/' + subrubroId + '/abm')
                .then(res => {
                    commit('SET_SUBRUBRO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let error = '';

            let codigo = '';
            if (!isNaN(state.codigo)) {
                let numeroCodigo = parseInt(state.codigo);
                codigo = numeroCodigo.toString().padStart(3, '0');
            } else {
                save = false;
                error = 'El código de subrubro no es válido. Verifique la información ingresada.';
            }

            if (save) {
                let subrubro= {
                    rubroId: state.rubroId,
                    codigo: codigo,
                    nombre: state.nombre.trim().toUpperCase(),
                    excluidoCalculoRN: ((/true/i).test(state.excluidoCalculoRN)),
                    excluidoResumenGastos: ((/true/i).test(state.excluidoResumenGastos)),
                }

                let url = 'subrubros';
                if (state.id != 0) {
                    url += '/' + state.id;
                    subrubro.rowVersion = state.rowVersion;
                }
                apiAxios.post(url, subrubro)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(error);
            }
        })
    },
    delete ( {}, subrubroId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('subrubros/' + subrubroId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}